var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"value":_vm.show,"width":"400"},on:{"input":r=> _vm.show = r}},[_c('v-card',[_c('v-card-text',[_vm._v(_vm._s(_vm.popup))])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }